import { jsxs, jsx } from 'react/jsx-runtime';
import { ExclamationmarkOctagonIcon } from '@flex-design-system/legacy-flex-icons';
import { styled } from '@flex-design-system/stitches-react';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef, useState } from 'react';
import { HelperTextSlot } from './components/slot/Slot.mjs';
import { helperText } from './helperText.vanilla.mjs';
import { getDisabledDataAttribute } from './utils/data-attribute.mjs';

const HelperText = forwardRef(
  ({
    children,
    className: classNameFromProps,
    disabled,
    leftSlot,
    state = "default",
    ...props
  }, forwardedRef) => {
    const [helperTextElement, setHelperTextElement] = useState(null);
    const composedRef = useComposedRefs(
      forwardedRef,
      (element) => setHelperTextElement(element)
    );
    const isWithInField = helperTextElement?.closest(
      '[data-scope="form-field"], [data-scope="text-field"], [data-scope="text-area"]'
    ) !== null;
    const className = classNames(
      helperText({ state, withInField: isWithInField }),
      classNameFromProps
    );
    return /* @__PURE__ */ jsxs(
      StyledDiv,
      {
        "data-scope": "helper-text",
        "data-part": "root",
        "data-state": state,
        ...getDisabledDataAttribute(disabled),
        className,
        ref: composedRef,
        ...props,
        children: [
          /* @__PURE__ */ jsx(HelperTextSlot, { "data-part": "left-slot", children: state === "error" ? /* @__PURE__ */ jsx(
            ExclamationmarkOctagonIcon,
            {
              "data-scope": "helper-text",
              "data-part": "error-state-icon",
              type: "fill"
            }
          ) : leftSlot }),
          children
        ]
      }
    );
  }
);
const StyledDiv = styled(Primitive.div);
HelperText.toString = () => '[data-scope="helper-text"][data-part="root"]';
HelperText.displayName = "HelperText";

export { HelperText };
//# sourceMappingURL=HelperText.mjs.map
